import { render } from "./SummaryBox.vue?vue&type=template&id=89454958&scoped=true"
import script from "./SummaryBox.vue?vue&type=script&lang=js"
export * from "./SummaryBox.vue?vue&type=script&lang=js"

import "./SummaryBox.vue?vue&type=style&index=0&id=89454958&scoped=true&lang=css"

import exportComponent from "/var/www/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89454958"]])

export default __exports__